import { render, staticRenderFns } from "./AccountUncHistoryBB.vue?vue&type=template&id=678d28f0&"
import script from "./AccountUncHistoryBB.vue?vue&type=script&lang=js&"
export * from "./AccountUncHistoryBB.vue?vue&type=script&lang=js&"
import style0 from "./AccountUncHistoryBB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports